/**
 * Whether a role is in force for this app (#544, known gap 70): one has been chosen, or there is none to choose.
 * Reads whose answer depends on the role — the rooms list, the room summary — wait for it.
 *
 * `offerable` is how many roles this app offers the account, null until `/api/me` answers. With two and none chosen
 * the role chooser is on screen, and a read then goes out with no `X-Acting-Role` — an answer for a role nobody
 * chose, which choosing one throws away with the rest of the cache before reading it again. A stored choice goes out
 * on every request as that header, so it needs no answer from `/api/me` first.
 *
 * Pure, and importing nothing at runtime, so `node --test` reads it directly (`roleInForce.test.js`).
 */
export function roleInForce(offerable: number | null, actingRole: string | null): boolean {
  if (actingRole !== null) return true;
  return offerable !== null && offerable < 2;
}
